import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {redirectPage as strings} from "strings";

import LoadingSpinner from "components/LoadingSpinner";
import RedirectModal from "components/RedirectModal";

import {Pharmacy} from "liberty-core/api/models";
import {usePharmacy} from "liberty-core/api/react-query/pharmacy";

import styles from "./RedirectPage.module.css";

const DOMAIN = process.env.REACT_APP_IS_QA === "true" ? "test.rx365" : "rx365";

function getRedirectRouteWeb(
  redirectParams: URLSearchParams,
  pharmacy: Pharmacy,
) {
  const pageName = redirectParams.get("pageName")?.toUpperCase();

  if (!pharmacy.subdomain) return `https://${DOMAIN}.com`;
  if (
    pageName === "INSURANCECARDS" ||
    pageName === "TAXREPORT" ||
    pageName === "TRANSFERIN" ||
    pageName === "APPOINTMENTS" ||
    pageName === "REGISTER" ||
    pageName === "EXPRESSREGISTER"
  ) {
    return `https://${
      pharmacy.subdomain
    }.${DOMAIN}.com/redirect?${redirectParams.toString()}`;
  }
  if (pageName === "MEDICATIONS") {
    return `https://${pharmacy.subdomain}.${DOMAIN}.com/medications`;
  }
  // chat not on web as well as catching any other edge cases
  return `https://${pharmacy.subdomain}.${DOMAIN}.com`;
}

function getRedirectRouteMobile(redirectParams: URLSearchParams) {
  return `https://${DOMAIN}.com/navigate-page/mobile?${redirectParams.toString()}`;
}

export default function RedirectPage() {
  const [searchParams] = useSearchParams();
  const {data: pharmacy, isLoading} = usePharmacy(
    parseInt(searchParams.get("storeId") ?? ""),
  );
  const [redirectModalVisible, setRedirectModalVisible] = useState(false);
  const windowWidth = window.innerWidth;
  const navigate = useNavigate();

  useEffect(() => {
    const pageName = searchParams.get("pageName")?.toUpperCase();
    if (
      !searchParams.has("storeId") ||
      (pageName !== "APPOINTMENTS" &&
        pageName !== "CHAT" &&
        pageName !== "INSURANCECARDS" &&
        pageName !== "MEDICATIONS" &&
        pageName !== "REGISTER" &&
        pageName !== "EXPRESSREGISTER" &&
        pageName !== "TAXREPORT" &&
        pageName !== "TRANSFERIN")
    ) {
      navigate("/");
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    if (!isLoading && pharmacy) {
      if (windowWidth > 770) {
        window.location.replace(getRedirectRouteWeb(searchParams, pharmacy));
      }
      setRedirectModalVisible(true);
    }
  }, [isLoading, pharmacy, searchParams, windowWidth]);

  return (
    <div>
      {isLoading ? (
        <div className={styles.loadingSpinnerContainer}>
          <LoadingSpinner />
        </div>
      ) : pharmacy ? (
        <RedirectModal
          visible={redirectModalVisible}
          redirectParams={searchParams}
          pharmacy={pharmacy}
          redirectRouteWeb={getRedirectRouteWeb(searchParams, pharmacy)}
          redirectRouteMobile={getRedirectRouteMobile(searchParams)}
        />
      ) : (
        <div>{strings.pharmacyNotFound}</div>
      )}
    </div>
  );
}
